import {
  sportPresentation,
  type SupProfileKey,
} from "./sport-profiles";

export type SportConfig = {
  locationType: "ski" | "surf" | "sailing";
  label: string;
  scoreKey: string;
  hasPricing: boolean;
  isBeta?: boolean;
};

export const SPORT_HUB_CONFIG: Record<string, SportConfig> = {
  ski: { locationType: "ski", label: "Ski", scoreKey: "piste", hasPricing: true },
  "off-piste": { locationType: "ski", label: "Off-Piste", scoreKey: "off-piste", hasPricing: true },
  touring: { locationType: "ski", label: "Touring", scoreKey: "touring", hasPricing: false },
  mtb: { locationType: "ski", label: "MTB", scoreKey: "mtb", hasPricing: false },
  surf: { locationType: "surf", label: "Surf", scoreKey: "surf", hasPricing: false },
  bodyboarding: { locationType: "surf", label: "Bodyboarding", scoreKey: "bodyboarding", hasPricing: false },
  wind: { locationType: "surf", label: "Wind", scoreKey: "wind", hasPricing: false },
  foil: { locationType: "surf", label: "Foil", scoreKey: "foil", hasPricing: false },
  "downwind-foil": { locationType: "surf", label: "Downwind Foil", scoreKey: "downwind-foil", hasPricing: false },
  "wing-foil": { locationType: "surf", label: "Wing Foil", scoreKey: "wing-foil", hasPricing: false },
  diving: { locationType: "surf", label: "Diving", scoreKey: "diving", hasPricing: false },
  swimming: { locationType: "surf", label: "Swimming", scoreKey: "swimming", hasPricing: false },
  sup: { locationType: "surf", label: "SUP", scoreKey: "sup", hasPricing: false },
  sailing: { locationType: "sailing", label: "Club Sailing", scoreKey: "sailing-club", hasPricing: false },
  "sailing-club": { locationType: "sailing", label: "Club Sailing", scoreKey: "sailing-club", hasPricing: false },
  "sailing-hp": { locationType: "sailing", label: "Performance Sailing", scoreKey: "sailing-hp", hasPricing: false },
};

export const ALL_HUB_SPORTS = Object.keys(SPORT_HUB_CONFIG);
export const MOUNTAIN_SPORTS = ALL_HUB_SPORTS.filter(
  (sport) => SPORT_HUB_CONFIG[sport].locationType === "ski",
);
export const COASTAL_SPORTS = ALL_HUB_SPORTS.filter(
  (sport) => SPORT_HUB_CONFIG[sport].locationType !== "ski",
);

export function sportHubConfigsForSupProfiles(
  allowedProfiles: readonly SupProfileKey[],
): Record<string, SportConfig> {
  if (allowedProfiles.length === 0) return SPORT_HUB_CONFIG;
  const configs = Object.fromEntries(
    Object.entries(SPORT_HUB_CONFIG).filter(([key]) => key !== "sup"),
  ) as Record<string, SportConfig>;
  for (const profile of allowedProfiles) {
    const presentation = sportPresentation(profile);
    configs[profile] = {
      locationType: "surf",
      label: presentation.label,
      scoreKey: profile,
      hasPricing: false,
      isBeta: true,
    };
  }
  return configs;
}
